import axios from "axios";

const instance = axios.create({
  
    //  baseURL: "https://swtprime.com/passilo_backend/public/api/", // prime server
      // baseURL: "http://127.0.0.1:8000/api/",                       // local server
  //  baseURL:"http://192.168.1.61:8000/api/"   ,   
     // baseURL: "https://races.swtgrid.com/api/",   // swtgrid server
      baseURL: "https://backend.passilo.com/api/",     

  headers: {
    'accept': 'application/json',
    'Access-Control-Allow-Origin': "*",
    'content-type': 'application/x-www-form-urlencoded',
    'Access-Control-Allow-Credentials': 'true',
    Authorization: {
      toString() {
        return `Bearer ${localStorage.getItem("RacesToken") ? JSON.parse(localStorage.getItem("RacesToken")).token : ""}`;
      },
    },
  },
});

export default instance;
